export const ADVERTISING_ROUTE_NAMES = {
  ADVERTISING: 'advertising',
  ADVERTISING_ADD_CAMPAIGN: 'advertising-add-campaign',
};
